import TextInput from "components/controls/TextInput";
import { useForm } from "modules/forms";
import { StyledControlContainer } from "shared/styled/control.styled";
import { StyledPanelTitle } from "shared/styled/panel.stayled";
import { NearMissEntity } from "shared/types/domain/NearMissEntity";

interface IssueDetailsProps {
    readOnly: boolean;
};

const IssueDetails = ({
    readOnly
}: IssueDetailsProps) => {
    const { formData, updateFields, formErrors } = useForm<NearMissEntity>();

    return (
        <>
            <StyledPanelTitle>Explination of Issue</StyledPanelTitle>

            <StyledControlContainer>
                <TextInput
                    label={"What Happened?"}
                    multiline
                    value={formData?.whatHappened}
                    errorMessage={formErrors?.whatHappened}
                    onChange={(e, v) => updateFields({
                        whatHappened: { runValidation: true, value: v }
                    })}
                    disabled={readOnly}
                    required
                />
            </StyledControlContainer>

            <StyledControlContainer>
                <TextInput
                    label={"How would you stop this happening again?"}
                    multiline
                    value={formData?.howToStop}
                    errorMessage={formErrors?.howToStop}
                    onChange={(e, v) => updateFields({
                        howToStop: { runValidation: true, value: v }
                    })}
                    disabled={readOnly}
                    required
                />
            </StyledControlContainer> 
        </>
    )
};

export default IssueDetails;